































import {Component, Vue} from "vue-property-decorator";
import myTitle from "./components/myTitle.vue";

@Component({
  components: {
    myTitle
  },
})

export default class guardService extends Vue{
  path = 'assets/solution/guardService/';

  cardContent = [
    {src:this.path+'xiaolv.png',title:'服务团队效率低',text:'商用显示设备脆弱易受损，是企业的门面招牌，若不能及时处理将会导致企业的业务无法正常进行，同时影响企业的对外宣传和企业形象等问题',offset:2},
    {src:this.path+'baoxiu.png',title:'报修渠道太单一',text:'传统电话报修效率低，很难全面了解企业提供的服务内容，客户体验差',offset:1},
    {src:this.path+'jindu.png',title:'服务进度不明确',text:'服务状况难以跟进，服务商没有成熟的管理系统，不清楚售后服务是否按企业要求的标准进行，容易与客户产生争议，影响企业口碑',offset:1},
    {src:this.path+'weihu.png',title:'维护历史难追溯',text:'设备维护的历史情况没有备案或者很难查询，管理方式不科学、不合理',offset:2},
    {src:this.path+'zhiliang.png',title:'服务质量没保障',text:'服务质量参差不齐，难以保障，很多服务商没有自有团队，服务人员不够专业，可能影响企业声誉',offset:1},
    {src:this.path+'jixiao.png',title:'绩效考核不到位',text:'企业对服务人员的满意度无法清晰反馈，服务商不能做针对性改进，用户体验难以提高',offset:1},
  ];
  solutions = [
    {
      img: this.path+'first.png',
      title:'多渠道快速售后处理',text:'平台支持APP、微信、二维码、网页、电话等多种方式提交服务请求，系统统一处理工单，服务人员将第一时间接单，快速响应，及时处理'
    },
    {
      img: this.path+'second.png',
      title:'完善的绩效考核机制',text:'用户可对服务人员的满意度进行评价，评价结果将会对服务人员的绩效产生影响，用量化满意度的方式促进平台进步，从而更好地满足用户需求'
    },
    {
      img: this.path+'third.png',
      title:'售后进度实时跟踪',text:'平台将实时更新工单情况，消息可通过短信、手机app、微信等多种方式通知用户，让您全程掌握售后信息，轻松进行售后管理'
    },
    {
      img: this.path+'fourth.png',
      title:'可视化设备状况',text:'所有设备售后记录都将由系统备案整理，可在设备管理中清晰了解每台设备状况，帮助用户做出科学保养计划'
    },
  ];
}
